<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GTJcJ0/tc-custom/9781526774194.jpg?1704297302398" alt="This image is the cover for the book Stryker Interim Combat Vehicle, LandCraft"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Stryker Interim Combat Vehicle, LandCraft
      </h1>
      <p class="bookDescription body article font2">
        <b>This illustrated modeling guide reviews the full range of kits and accessories available to model the Stryker and LAV III in all the major scales.</b><br/><br/>The Stryker interim combat vehicle was a stop-gap measure, designed to help the United States project its military force in hotspots around the world. First deployed in Iraq in 2003, it has since proved itself an integral part of the US’s warfighting capability. Today the Stryker has been adapted to face the new threat of a resurgent Russia.<br/><br/>This volume in the LandCraft series of modeling guides examines the Stryker and LAV III in US, Canadian and New Zealand service. In addition to describing the design, development, and operational history of the Stryker and LAV III, David Grummitt gives a full account of available modeling kits and accessories. Six builds are featured, covering the most important variants. Detailed color profiles provide both reference and inspiration for modelers and military enthusiasts alike.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Grummitt
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen & Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07ddd092